import indexTemplate from "./indexTemplate";
// import registrationAppleSplashTemplate from "./registrationAppleSplashTemplate";
import registrationWithPinTemplate from "./registrationWithPinTemplate";
import registrationGroupPasswordTemplate from "./registrationGroupPasswordTemplate";
import regErrorTemplate from "./regErrorTemplate";
import registrationSummaryTemplate from "./registrationSummaryTemplate";
import iraPreAccountOpeningTemplate from "./iraPreAccountOpeningTemplate";
import registrationWithoutPinTemplate from "./registrationWithoutPinTemplate";

var registrationRoute = function ($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider) {

    $urlRouterProvider.when('/register', '/register/');
    // $urlMatcherFactoryProvider.strictMode(false);

    $stateProvider

        // registration parent view =================================
        .state('register', {
            url: '/register?accu',
            abstract: true,
            template: indexTemplate,
            controller: 'registrationController',
            data: {
                fullHeight: true,
                title: 'Registration account lookup'
            }
        })
        // pre register splash page =================================
        // applePreRegister
        .state('register.appleSplash', {
            url: '/appleSplash',
            templateUrl: "./registrationAppleSplash",
            controller: 'registrationController',
            data: {
                fullHeight: true
            }
        })

        // registration with  pin View =================================
        // registerWithPin
        .state('register.withPin', {
            url: '/pin',
            template: registrationWithPinTemplate,
            controller: 'registrationController',
            data: {
                fullHeight: true
            }
        })

        // registration with  Group Password =================================
        // registerWithGroupPassword
        .state('register.withGroupPassword', {
            url: '/group',
            template: registrationGroupPasswordTemplate,
            controller: 'registrationWithGroupPasswordController',
            data: {
                fullHeight: true,
                title: 'Registration account lookup'
            }
        })

        .state('registrationHardStopError', {
            url: '/registration/regError',
            template: regErrorTemplate,
            controller: 'registrationController',
            data: {
                fullHeight: true,
                title: 'Registration Error'
            },
            params: {
                hardStopError: {
                    value: 'true',
                    squash: true
                }
            }
        })

        // registration summary =================================
        .state('registrationSummary', {
            url: '/registration-summary',
            //    abstract:true,
            template: registrationSummaryTemplate,
            controller: 'registrationSummaryController',
            controllerAs: 'vm',
            data: {
                fullHeight: true,
                title: 'Registration Summary'
            },
            resolve: {
                groupId: ['$q', 'primaryPlanService', function ($q, primaryPlanService) {
                    var deferred = $q.defer();

                    primaryPlanService.getPrimaryPlan()
                        .then(function (primaryPlan) {
                            deferred.resolve(primaryPlan.gaId);
                        }, function () {
                            deferred.reject();
                        });

                    return deferred.promise;
                }]
            }
        })
        .state('preAccountOpening', {
            url: '/open-account-registration',
            template: iraPreAccountOpeningTemplate,
            controller: 'preAccountOpeningController',
            controllerAs: 'paoCtl'
        })
        // registration without pin View =================================
        // registerWithoutPin
        .state('register.withoutPin', {
            url: '/:flowName',
            template: registrationWithoutPinTemplate,
            controller: 'registrationController',
            data: {
                fullHeight: true
            }
        });

};

registrationRoute.$inject = ['$stateProvider', '$urlRouterProvider', '$urlMatcherFactoryProvider'];
export default registrationRoute;
